export const ZATCA_DOWNLOADS_FALLBACK = 70_206

const gemNames = ["zatca", "zatca-sdk"] as const

type Fetcher = (
  input: string | URL | Request,
  init?: RequestInit,
) => Promise<Response>

interface RubyGemsResponse {
  downloads?: unknown
}

export async function fetchZatcaDownloads(
  fetcher: Fetcher = fetch,
  signal?: AbortSignal,
) {
  const responses = await Promise.all(
    gemNames.map((name) =>
      fetcher(`https://rubygems.org/api/v1/gems/${name}.json`, {
        headers: { Accept: "application/json" },
        signal,
      }),
    ),
  )

  if (responses.some((response) => !response.ok)) {
    throw new Error("RubyGems request failed")
  }

  const gems = (await Promise.all(
    responses.map((response) => response.json()),
  )) as RubyGemsResponse[]

  const downloads = gems.map(({ downloads: value }) => {
    if (!Number.isSafeInteger(value) || Number(value) < 0) {
      throw new Error("Unexpected RubyGems response")
    }

    return Number(value)
  })

  return downloads.reduce((sum, value) => sum + value, 0)
}
